<script setup lang="ts">
// A Pilotage section whose code failed to load for another reason than a stale
// chunk (that case reloads the page): say so, never a skeleton that stays.
import { useI18n } from 'vue-i18n'
import Message from 'primevue/message'

const { t } = useI18n()
</script>

<template>
  <div class="p-4" data-testid="pilotage-section-error">
    <Message severity="warn" :closable="false">{{ t('referentials.sectionLoadFailed') }}</Message>
  </div>
</template>
